import { render, staticRenderFns } from "./bgs-resources.vue?vue&type=template&id=5f04c3fb"
import script from "./bgs-resources.vue?vue&type=script&lang=js"
export * from "./bgs-resources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports